import React from "react";

import { DRAWER_WIDTH, W2 } from "@components/Constants";

import Markdown from "./Markdown";

type Props = {
  json: string;
};

const JSON_INDENT = 2;
const CODE_FENCE = "```";

const drawerInnerWidth = DRAWER_WIDTH - W2 * 2;

const containerStyle = {
  width: drawerInnerWidth,
  overflowX: "auto" as const,
  whiteSpace: "nowrap" as const,
};

const JsonMarkdown = ({ json }: Props): JSX.Element => {
  const object = JSON.parse(json);
  const formattedJson = JSON.stringify(object, null, JSON_INDENT);

  const text = `${CODE_FENCE}\n${formattedJson}\n${CODE_FENCE}`;

  return (
    <div style={containerStyle}>
      <Markdown text={text} />
    </div>
  );
};

export default JsonMarkdown;
